import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-billing-policy/:billingPolicyId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    servicePlanItemId: string;
    billingPolicyId: string;
}
const mutationFn = ({ servicePlanItemId, billingPolicyId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { servicePlanItemId, billingPolicyId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteServicePlanBillingPolicy };
